import { NgModule } from '@angular/core';
import { PrizmPrimitiveMonthPickerComponent } from './primitive-month-picker.component';

/**
 * @deprecated
 * use standalone
 * */
@NgModule({
  imports: [PrizmPrimitiveMonthPickerComponent],
  exports: [PrizmPrimitiveMonthPickerComponent],
})
export class PrizmPrimitiveMonthPickerModule {}
